/**
 * Format customer data api response
 *  fully qualified name is the  customer display name in qbo : that'll be our reference, which cannot be modify
 */

export function getFormattedCustomer(customerList) {
  return customerList.map((item) => ({
    id: item.Id,
    Email: item.PrimaryEmailAddr?.Address || '',
    Phone: item.PrimaryPhone?.FreeFormNumber || '',
    BillableStatus: item.BillableStatus ? item.BillableStatus : false,
    MarkUpPercentage: item.MarkUpPercentage || '',
    customerStatus: 'Enabled',
    Taxable: item.Taxable || '',

    BillAddrId: item.BillAddr?.Id || '',
    Line1: item.BillAddr?.Line1 || '',
    City: item.BillAddr?.City || '',
    CountrySubDivisionCode: item.BillAddr?.CountrySubDivisionCode || '',
    PostalCode: item.BillAddr?.PostalCode || '',
    Lat: item.BillAddr?.Lat || '',
    Long: item.BillAddr?.Long,

    ShipAddrId: item.ShipAddr?.Id || '',
    ShipAddrLine1: item.ShipAddr?.Line1 || '',
    ShipAddrCity: item.ShipAddr?.City || '',
    ShipAddrCountrySubDivisionCode: item.ShipAddr?.CountrySubDivisionCode || '',
    ShipAddrPostalCode: item.ShipAddr?.PostalCode || '',
    ShipAddrLat: item.ShipAddr?.Lat || '',
    ShipAddrLong: item.ShipAddr?.Long,

    Job: item.Job || '',
    ParentRef: item?.ParentRef?.value || '',
    BillWithParent: item.BillWithParent || '',
    Balance: item.Balance || '',
    BalanceWithJobs: item.BalanceWithJobs || '',

    PreferredDeliveryMethod: item.PreferredDeliveryMethod || '',
    IsProject: item.IsProject || '',
    domain: 'QBO',
    sparse: item.sparse || '',
    Id: item.Id || '',
    SyncToken: item.SyncToken || '',

    Title: item.Title || '',
    Suffix: item.Suffix || '',
    GivenName: item.GivenName || '',
    MiddleName: item.MiddleName || '',
    FamilyName: item.FamilyName || '',
    FullyQualifiedName: item.FullyQualifiedName || '',
    CompanyName: item.CompanyName || '',
    DisplayName: item.DisplayName || '',
    PrintOnCheckName: item.PrintOnCheckName || '',
    Active: item.Active || '',
    Mobile: {
      FreeFormNumber: item.Mobile?.FreeFormNumber || ''
    },
    PrimaryEmailAddr: {
      Address: item.PrimaryEmailAddr?.Address || ''
    },
    opsAllowanceApplicable: item?.opsAllowanceApplicable
  }));
}

/**
 * format customer payload
 * while updating customer it must contains sparse true, id and SyncToken
 */
//if any of this column's value is clicked, then can be inline editing
export const CUSTOMER_INLINE_COLUMNS = [
  'Email',
  'Phone',
  'GivenName',
  'MiddleName',
  'FamilyName',
  'Title',
  'Suffix',
  'Taxable',
  'Line1',
  'City',
  'CountrySubDivisionCode',
  'PostalCode',
  'Job',
  'ParentRef',
  'BillWithParent',
  'PreferredDeliveryMethod',
  'IsProject',
  'Active',
  'customerStatus'
];

export const requiredRule = {
  isValid: (value) => (value?.trim()?.length ?? 0) > 0,
  errorText: 'This field is required'
};

export const validationRules = {
  Phone: {
    // Phone is optional — only validate format when a value is provided
    // Australian mobiles are 10 digits: 04 + 8 digits (e.g. 0412 345 678)
    isValid: (Phone) => !Phone || /^04\d{8}$/.test(Phone),
    errorText: 'Phone must be a 10-digit Australian mobile starting with 04 (e.g. 0412345678).'
  },
  Email: requiredRule,
  GivenName: requiredRule,
  FamilyName: requiredRule
};

export const validateCustomerChanges = (changed) =>
  Object.fromEntries(
    Object.entries(changed || {}).map(([rowId, rowChanges]) => [
      rowId,
      Object.fromEntries(
        Object.entries(rowChanges || {})
          .filter(([field]) => validationRules[field])
          .map(([field, value]) => {
            const rule = validationRules[field];
            const isValid = Boolean(rule.isValid(value));
            return [field, { isValid, error: isValid ? null : rule.errorText }];
          })
      )
    ])
  );

export const hasCustomerValidationErrors = (changed, status) =>
  Object.keys(changed || {}).some((rowId) =>
    Object.keys(changed[rowId] || {}).some((field) => status[rowId]?.[field]?.isValid === false)
  );
